import { useAccessToken } from 'hooks/context';

import type { Alert } from '../../atoms/AlertBanner';
import { AlertBanner } from '../../atoms/AlertBanner';

const impersonationAlert: Alert[] | undefined = [
  {
    id: 1,
    alert_message:
      "You're impersonating another user. Actions taken will be on behalf of that user."
  }
];

export function ImpersonationBanner() {
  const { isImpersonating } = useAccessToken();

  if (!isImpersonating) return null;

  return (
    <div>
      <AlertBanner alerts={impersonationAlert} kind="warning" />
    </div>
  );
}
